module.exports = __webpack_public_path__ + "img/BEAR_HERO.7ca71fa3.png";